export const navigateAfterCheckout = order => {
  if (typeof window === "undefined") return
  window.localStorage.setItem(
    "checkoutData",
    JSON.stringify({ hash: order.orderHash })
  )
  const nextPath = order.needIdVerification
    ? `/verification/?order_hash=${encodeURIComponent(order.orderHash)}`
    : `/billing/checkout-complete/?order_hash=${encodeURIComponent(order.orderHash)}`
  window.location.assign(nextPath)
}
